import React from 'react';
import { motion } from 'framer-motion';
export function PrivacySection() {
  return <section id="privacy" className="bg-sure-dark w-full py-24 md:py-32" data-id="element-185">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start" data-id="element-187">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col" data-id="element-188">
            <h2 className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-6" data-id="element-189">
              PRIVACY BY DESIGN
            </h2>
            <h3 className="text-sure-white text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.1]" data-id="element-190">
              Built for trust.
              <br data-id="element-191" />
              Deployed without compromise.
            </h3>
          </motion.div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.2
        }} className="flex flex-col space-y-6 text-sure-gray text-base md:text-lg font-light leading-relaxed" data-id="element-192">
            <p data-id="element-193">
              We don't track individuals. We don't store faces. We don't build
              profiles. SURE AI was designed from day one around a simple
              principle: you can understand how people move without knowing who
              they are.
            </p>
            <p data-id="element-194">
              Every frame is processed locally and discarded. What remains is
              structured, anonymised intelligence — compliant with GDPR, the UK
              Data Protection Act 2018, and built to meet the scrutiny of
              public-sector procurement.
            </p>
            <p className="text-sure-white font-medium" data-id="element-195">
              Privacy isn't a feature we added. It's the foundation everything
              else is built on.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}